// HowItWorksVideo.js — the full Layered Read explainer (5 min) in a modal, opened from the orientation
// card ("watch how it works"). Same files as /how-layered-read-works (public/video/layered-read/).
// Tracking: public/assets/lr_video_track.js (loaded on first open) reports play / 25-50-75-100% /
// CTA under data-lr-track = `surface` ('full-lrtab' in the analysis page, 'full-icicle' standalone).
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

const NAVY = '#14536e';

export default function HowItWorksVideo({ open, onClose, surface = 'full-icicle' }) {
  useEffect(() => {
    if (!open) return undefined;
    try {
      if (!window.__lrVideoTrack && !document.getElementById('lr-video-track-js')) {
        const s = document.createElement('script'); s.id = 'lr-video-track-js'; s.src = '/assets/lr_video_track.js?v=2'; s.defer = true;
        document.head.appendChild(s);
      }
    } catch (e) { /* tracking must never break the UI */ }
    const onKey = (e) => { if (e.key === 'Escape') { e.stopPropagation(); onClose(); } };
    window.addEventListener('keydown', onKey, true);
    return () => window.removeEventListener('keydown', onKey, true);
  }, [open, onClose]);
  if (!open || typeof document === 'undefined') return null;
  return createPortal(
    <div role="dialog" aria-label="How the Layered Read works" onClick={onClose}
      style={{ position: 'fixed', inset: 0, zIndex: 199999, background: 'rgba(8,24,34,.72)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ width: 'min(1100px, 100%)', background: '#0b2a3b', borderRadius: 14, boxShadow: '0 24px 70px rgba(0,0,0,.5)', overflow: 'hidden' }}>
        <video data-lr-track={surface} controls autoPlay playsInline preload="metadata" poster="/video/layered-read/poster-full.jpg"
          style={{ display: 'block', width: '100%', height: 'auto', aspectRatio: '16 / 9', background: '#0b2a3b' }}>
          <source src="/video/layered-read/layered-read-full.mp4" type="video/mp4" />
          <track kind="captions" srcLang="en" label="English" src="/video/layered-read/layered-read-full.vtt" default />
        </video>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, padding: '10px 16px', color: '#fff', fontSize: '.9rem' }}>
          <a href="/how-layered-read-works#axes" target="_blank" rel="noopener" data-lr-video-cta="guide" data-lr-video={surface}
            style={{ color: '#fff', fontWeight: 700, textDecoration: 'underline', textUnderlineOffset: 3 }}>
            Guide to every group and axis ↗
          </a>
          <button type="button" onClick={onClose} style={{ all: 'unset', marginLeft: 'auto', cursor: 'pointer', color: '#cfe0e8', fontWeight: 700 }}>✕ Close</button>
        </div>
      </div>
    </div>,
    document.body
  );
}
